export function getNotificationBreadCrumbs() {
  return [
    {
      label: 'Все уведомления',
      to: '/notifications'
    }
  ];
}
